// import languages from '../languages/index';

let configFunction = ($translateProvider, $provide, $qProvider, $compileProvider) => {

    $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|file|tel):/);

	$translateProvider.translations('hu', window.languages.hu);
	$translateProvider.translations('en', window.languages.en);
	$translateProvider.preferredLanguage('hu');
	// security issue, check it if version above 3.0
	// https://www.shiwaforce.com/angular-translate-utmutato-biztonsagi-megfontolasok/
	$translateProvider.useSanitizeValueStrategy('escape');

	/**
	 * disable annoying unhandled possible promise rejection error
	 */
	$qProvider.errorOnUnhandledRejections(false);

	/**
	 * source: https://plnkr.co/edit/0tzee8RpoD2WeFSJX1z1?p=preview
	 * Decorator for mdAutoComplete directive
 	 */
	function mdAutoCompleteDirectiveOverride($delegate) {
		let directive = $delegate[0];
		// need to append to base compile function
		let compile = directive.compile;

		// add our custom attribute to the directive's scope
		angular.extend(directive.scope, {
			menuContainerClass: '@?mdMenuContainerClass'
		});

		// recompile directive and add our class to the virtual repeat container
		directive.compile = function(element, attr) {
			let template = compile.apply(this, arguments);
			let menuContainerClass = attr.mdMenuContainerClass ? attr.mdMenuContainerClass : '';
			let menuContainer = element.find('md-virtual-repeat-container');

			menuContainer.addClass(menuContainerClass);

			// recompile the template
			return function() {
				template.apply(this, arguments);
			};
		};

		return $delegate;
	}

	// add additional function to md-autocomplete
	$provide.decorator('mdAutocompleteDirective', mdAutoCompleteDirectiveOverride);
	mdAutoCompleteDirectiveOverride.$inject = ['$delegate'];
};

export default configFunction;
